import React from "react";
import Helper from "../../helper";

const HorseRacing = () => {
  const userInfo = Helper()
  const horseData = [
    { name: "Bathurst (AUS) 2nd Jul", time: "2nd Jul 15:07" },
    { name: "Redcliffe (AUS) 2nd Jul", time: "2nd Jul 15:07" },
    { name: "Bendigo (AUS) 2nd Jul", time: "2nd Jul 15:07" },
    { name: "Bathurst (AUS) 2nd Jul", time: "2nd Jul 15:07" },
    { name: "Redcliffe (AUS) 2nd Jul", time: "2nd Jul 15:07" },
  ];

  return (
    // <div className={` ${!userInfo ? 'w-full' : ' ml-[15%]'}`}>
    <div className={`${userInfo ? 'ml-0 lg:ml-[15%]' : 'ml-0'} w-full`}>
      <div className="text-center bg-[#18adc5] py-1 border">
        <p className="text-white text-left text-[14px] ml-2 font-bold">Horse Racing</p>
      </div>

      <div className="py-1 flex bg-white   overflow-x-auto whitespace-nowrap no-scrollbar border">
        {horseData.map((horse, index) => (
          <a
            key={index}
            href="#"
            className="flex items-center bg-white   p-2 mx-2 min-w-max hover:bg-gray-100 transition"
          >
            <img
              src="https://images.staticcontent.io/rde/login/horse-login.svg"
              alt="horse"
              className="w-10 h-10 mr-2"
            />
            <div className="text-center text-black text-sm" style={{fontWeight:"600",}}>
              <div>{horse.name}</div>
              <div className="text-black-500 text-sm " style={{fontWeight:"600",}}>{horse.time}</div>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
};

export default HorseRacing;
